import React, { useState, memo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Book } from 'lucide-react';
const tomos = [{
  id: 1,
  title: 'El Camino de los Números — Primer Grado',
  subtitle: 'La base que define todo el ciclo',
  desc: 'Secuencias didácticas completas para que tus alumnos construyan el sentido del número, la serie numérica hasta 150, las operaciones básicas con comprensión y las figuras geométricas elementales. Con fichas imprimibles y progresión trimestral.',
  bullets: ['Numeración hasta 150 con sentido', 'Suma y resta en contexto real', 'Figuras geométricas básicas', 'Diagnóstico y evaluaciones trimestrales']
}, {
  id: 2,
  title: 'Desarmando el Sistema — Segundo Grado',
  subtitle: 'Sistema posicional e introducción a la multiplicación',
  desc: 'Estructura paso a paso para dominar el sistema de numeración hasta el 1.000 y sentar las bases conceptuales de la multiplicación sin memorización mecánica temprana.',
  bullets: []
}, {
  id: 3,
  title: 'Multiplicar Mundos — Tercer Grado',
  subtitle: 'Tablas, división y geometría con instrumentos',
  desc: 'Secuencias para construir el repertorio multiplicativo, introducir la división como reparto y partición, y comenzar el uso formal de regla y escuadra.',
  bullets: []
}, {
  id: 4,
  title: 'El Club de las Fracciones — Cuarto Grado',
  subtitle: 'Fracciones, decimales y proporcionalidad directa',
  desc: 'El quiebre del ciclo: cómo enseñar números racionales para que realmente se entiendan. Relación entre fracciones, decimales y situaciones de reparto.',
  bullets: []
}, {
  id: 5,
  title: 'Expertos en Proporciones — Quinto Grado',
  subtitle: 'Fracciones avanzadas, porcentajes y el número π',
  desc: 'Profundización en operaciones con racionales, cálculo de porcentajes en contexto real y exploración de la circunferencia y el círculo.',
  bullets: []
}, {
  id: 6,
  title: 'Camino al Secundario — Sexto Grado',
  subtitle: 'Potencias, números enteros, álgebra inicial y estadística',
  desc: 'El puente perfecto hacia la escuela media. Introducción al pensamiento algebraico, análisis de datos y consolidación de todos los ejes matemáticos.',
  bullets: []
}];
export const TomosAccordion = () => {
  const [openId, setOpenId] = useState<number | null>(1);
  return <section className="py-20 bg-cream" data-id="element-269">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-270">
        <div className="text-center mb-12" data-id="element-271">
          <h2 className="text-sm font-bold text-brand-orange tracking-widest uppercase mb-2" data-id="element-272">
            CONTENIDO COMPLETO
          </h2>
          <h3 className="text-3xl md:text-4xl font-heading font-bold text-gray-900 mb-4" data-id="element-273">
            LOS 6 TOMOS
          </h3>
          <p className="text-xl text-gray-600" data-id="element-274">
            Tu hoja de ruta para enseñar matemática de 1° a 6° grado sin
            improvisar
          </p>
          <p className="text-sm text-brand-green font-medium mt-4 bg-brand-green/10 inline-block px-4 py-1 rounded-full" data-id="element-275">
            Tocá cada tomo para ver lo que incluye 👆
          </p>
        </div>

        <div className="space-y-4" data-id="element-276">
          {tomos.map(tomo => <div key={tomo.id} className={`bg-white rounded-2xl border overflow-hidden transition-colors ${openId === tomo.id ? 'border-brand-orange shadow-md' : 'border-gray-200 hover:border-brand-orange/50'}`} data-id="element-277">
              <button onClick={() => setOpenId(openId === tomo.id ? null : tomo.id)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-278">
                <div className="flex items-center gap-4" data-id="element-279">
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${openId === tomo.id ? 'bg-brand-orange text-white' : 'bg-cream-dark text-brand-green'}`} data-id="element-280">
                    <Book size={24} data-id="element-281" />
                  </div>
                  <div data-id="element-282">
                    <h4 className="font-heading font-bold text-lg text-gray-900" data-id="element-283">
                      TOMO {tomo.id}: {tomo.title.split('—')[0]}
                    </h4>
                    <p className="text-sm text-gray-500" data-id="element-284">
                      — {tomo.title.split('—')[1]}
                    </p>
                  </div>
                </div>
                <ChevronDown className={`text-gray-400 transition-transform duration-300 ${openId === tomo.id ? 'rotate-180 text-brand-orange' : ''}`} data-id="element-285" />
              </button>

              <AnimatePresence data-id="element-286">
                {openId === tomo.id && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-287">
                    <div className="px-6 pb-6 pt-2 border-t border-gray-100 ml-16" data-id="element-288">
                      <p className="font-semibold text-brand-green mb-3" data-id="element-289">
                        {tomo.subtitle}
                      </p>
                      <p className="text-gray-600 mb-4 leading-relaxed" data-id="element-290">
                        {tomo.desc}
                      </p>

                      {tomo.bullets.length > 0 && <ul className="space-y-2" data-id="element-291">
                          {tomo.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-2 text-sm text-gray-700" data-id="element-292">
                              <div className="mt-1.5 w-1.5 h-1.5 bg-brand-orange rounded-full flex-shrink-0" data-id="element-293" />
                              {bullet}
                            </li>)}
                        </ul>}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
};